import { Box, Button, Card, CardContent, Grid, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PermissionContext } from "../../contexts/PermissionContext";
import { IContractActionsFormSection } from "../../interfaces";
import { Role } from "../../utils";
import { DeleteDraftDialog } from "../Shared/DeleteDraftDialog";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { UnknownStatus } from "../Shared/UnknownStatus";

const DraftActions = (deleteCallback: () => void, submitCallback?: () => void) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [showDeletePrompt, setShowDeletePrompt] = useState<boolean>(false);

    const onDelete = (confirm: boolean) => {

        if (confirm) {
            setShowDeletePrompt(false);
            setLoading(true);
            deleteCallback();

        } else setShowDeletePrompt(false);
    }

    return (
        <Card>

            <FormSectionHeader label="Submit Request" />

            <CardContent>


                <Typography variant="subtitle1">
                    Once you have entered the required details and added all the materials you would like to include in the contract / lease spare list, you can submit it for approval.
                </Typography>

                <Typography variant="subtitle1">
                    An expected return condition is required for each material in the contract / lease spare list.
                </Typography>
                <Typography variant="subtitle1">
                    Before submitting, you have the option to delete this draft; you can not delete a request once it has been submitted.
                </Typography>
                <Button variant="contained" onClick={submitCallback} disabled={submitCallback === undefined}>
                    Submit
                </Button>
                <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setShowDeletePrompt(true)}
                    disabled={loading}>Delete</Button>
            </CardContent>

            <DeleteDraftDialog open={showDeletePrompt} handleClose={onDelete} />

        </Card>
    );
}

const ApprovalActions = (
    allowed: boolean,
    approveCallback: () => void,
    rejectCallback: (r: string) => void,
) => {

    const [reasonPrompt, setReasonPrompt] = useState(false);
    const [reason, setReason] = useState("");


    return (
        <Card>

            <FormSectionHeader label="Request Approval" />

            {allowed ?
                <CardContent>


                    <Typography variant="subtitle1">
                        Please assess the materials in this contract / lease list request and either <strong>Approve</strong> or <strong>Reject</strong> the request.
                    </Typography>

                    <Button variant="contained" onClick={approveCallback} disabled={reasonPrompt}>
                        Approve
                    </Button>

                    <Button variant="outlined" onClick={() => setReasonPrompt(true)} disabled={reasonPrompt}>
                        Reject
                    </Button>

                    {reasonPrompt &&

                        <Box sx={{ my: 2 }}>

                            <Typography variant="subtitle1">
                                To <strong>Reject</strong> this request please provide a reason
                            </Typography>
                            <Grid container sx={{ my: 3 }}>
                                <Grid md={6} xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        required
                                        label="Reason"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <div>
                                <Button
                                    variant="contained"
                                    color="warning" onClick={() => rejectCallback(reason)}
                                    disabled={reason.length === 0}
                                >
                                    Confirm Rejection
                                </Button>
                                <Button variant="outlined" onClick={() => setReasonPrompt(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </Box>

                    }

                </CardContent>

                :

                <CardContent>

                    <Typography variant="subtitle1" color="GrayText">
                        This storage request is awaiting approval from Asset Protection. There are currently no further actions available.
                    </Typography>

                </CardContent>
            }

        </Card>
    );
}

const ApprovedActions = () => {
    return (<React.Fragment />);
}

const RejectedActions = (
    submitCallback: (() => void) | undefined,
    closeCallback: () => void,) => {
    return (
        <Card>

            <FormSectionHeader label="Close or Resubmit Request" />

            <CardContent>

                <Typography variant="subtitle1">
                    The contract / lease spare list was rejected. You can close this request or amend it and resubmit for approval.
                </Typography>

                <Button variant="contained" onClick={submitCallback} disabled={submitCallback === undefined}>
                    Resubmit
                </Button>
                <Button variant="outlined" onClick={closeCallback}>
                    Close
                </Button>

            </CardContent>
        </Card>

    );
}

const Closed = () => {
    return (<></>);
}

export const ContractActions: React.FC<IContractActionsFormSection> = ({
    status,
    formValid,
    materials,
    onSubmit,
    onDelete,
    onApprove,
    onReject,
    onClose,
    onComplete,
    readonly,
    ...props
}: IContractActionsFormSection) => {


    const permissionContext = useContext(PermissionContext);

    useEffect(() => {


    }, [materials])

    return (
        <div>
            {{
                0: UnknownStatus(),
                1: DraftActions(onDelete, formValid ? onSubmit : undefined),
                2: ApprovalActions(permissionContext.isRole(Role.Internal.AssetProtection), onApprove, onReject),
                3: ApprovedActions(),
                4: RejectedActions(formValid ? onSubmit : undefined, onClose),
                5: Closed(),
                6: Closed()
            }[status]}
        </div>
    );

}